<template>
  <div class="main pa-3">
    <v-toolbar elevation="0" class="custom-toolbar mt-4">
      <v-toolbar-title>
        <h1>
          {{ $vuetify.lang.t('$vuetify.eventManagement.eventManagement') }}
        </h1>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn
        v-on="on"
        elevation="0"
        class="pl-5 pr-5 mr-5 xs-full-width font-weight-light body-2 button-secondary"
        @click="openRecycleBin()"
      >
        <v-icon left>mdi-delete-outline</v-icon>
        {{ $vuetify.lang.t('$vuetify.eventManagement.recycleBin') }}
      </v-btn> -->
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            elevation="0"
            class="
              pl-5
              pr-5
              xs-full-width
              font-weight-light
              body-2
              button-primary
            "
          >
            <v-icon left>mdi-plus</v-icon>
            {{ $vuetify.lang.t('$vuetify.eventManagement.createEvent') }}
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="openPushNoticeDialog('COURSE')">
            <v-list-item-icon class="mr-2">
              <v-icon small>mdi-youtube-tv</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="font-weight-light subtitle-2">{{
                $vuetify.lang.t('$vuetify.eventManagement.type.course')
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click="openPushNoticeDialog('LIVE')">
            <v-list-item-icon class="mr-2">
              <v-icon small>mdi-access-point</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-light subtitle-2">{{
                $vuetify.lang.t('$vuetify.eventManagement.type.live')
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click="openPushNoticeDialog('EXAM')">
            <v-list-item-icon class="mr-2">
              <v-icon small>mdi-format-annotation-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-light subtitle-2">{{
                $vuetify.lang.t('$vuetify.eventManagement.type.exam')
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click="openPushNoticeDialog('URL')">
            <v-list-item-icon class="mr-2">
              <v-icon small>mdi-link-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-light subtitle-2">{{
                $vuetify.lang.t('$vuetify.eventManagement.type.link')
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click="openPushNoticeDialog('GENERAL')">
            <v-list-item-icon class="mr-2">
              <v-icon small>mdi-bell-ring</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-light subtitle-2">{{
                $vuetify.lang.t('$vuetify.eventManagement.type.general')
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar>

    <v-row>
      <v-col cols="12" class="px-7">
        <v-sheet color="white" class="pa-2">
          <v-row class="px-4">
            <v-col cols="12" sm="6" md="3">
              <span class="caption">{{
                $vuetify.lang.t('$vuetify.eventManagement.search')
              }}</span>
              <v-text-field
                class="subtitle-2 text-field-border"
                solo
                flat
                dense
                v-model="searchdata"
                :placeholder="
                  $vuetify.lang.t('$vuetify.eventManagement.searchEvent')
                "
                @change="searchInfo(searchdata)"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3" class="mt-auto">
              <p class="caption mb-0">
                {{ $vuetify.lang.t('$vuetify.eventManagement.status') }}
              </p>
              <v-btn-toggle
                class="mb-0"
                color="primary accent-3"
                background-color="white"
                mandatory
                v-model="status_toggle"
                @change="onSort"
              >
                <!-- <v-btn class="text-capitalize body-2" :width="`${(window.screen.width)/3}px`" height="40px">All</v-btn> -->
                <v-btn class="text-capitalize body-2" height="40px">{{
                  $vuetify.lang.t('$vuetify.eventManagement.statusAll')
                }}</v-btn>
                <v-btn class="text-capitalize body-2" height="40px">{{
                  $vuetify.lang.t('$vuetify.eventManagement.statusOn')
                }}</v-btn>
                <v-btn class="text-capitalize body-2" height="40px">{{
                  $vuetify.lang.t('$vuetify.eventManagement.statusOff')
                }}</v-btn>
              </v-btn-toggle>
            </v-col>
            <v-spacer></v-spacer>
            <v-col
              cols="12"
              sm="6"
              md="2"
              class="mt-auto"
              style="display: flex; justify-content: flex-end"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="pl-5 pr-5 btn-reload body-2"
                    height="40"
                    @click="refreshFilter"
                  >
                    <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </template>
                <span>{{
                  $vuetify.lang.t('$vuetify.eventManagement.reload')
                }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>
    <div class="px-4">
      <v-data-table
        :loading="loading"
        :headers="headers"
        hide-default-footer
        :items="notiList"
        class="pa-mb-5 font-weight-light"
      >
        <template v-slot:item.image="{ item }">
          <v-img
            :src="item.image"
            class="my-2 rounded-card"
            width="120"
            aspect-ratio="1.7"
          >
            <template v-slot:placeholder>
              <v-row class="ma-0" align="center" justify="center">
                <v-icon
                  v-if="!item.image"
                  class="mx-auto"
                  elevation="3"
                  size="70"
                  >mdi-image-outline</v-icon
                >
              </v-row>
            </template>
          </v-img>
        </template>

        <template v-slot:item.title="{ item }">
          <p class="mb-0">{{ item.title }}</p>
        </template>

        <template v-slot:item.detail="{ item }">
          <p class="mb-0">{{ item.detail }}</p>
        </template>

        <template v-slot:item.lectureType="{ item }">
          <p class="mb-0">{{ item.type.name }}</p>
          <!-- <span class="caption font-weight-light">
            <v-icon small>{{ item.type.icon }}</v-icon>
            {{ item.type.name }}
          </span> -->
          <!-- <v-chip
            v-if="item.type.name == 'Course'"
            color="blue lighten-5"
            label
            small
            text-color="blue"
          >
            <v-icon left small>{{ item.type.icon }}</v-icon>
            {{ item.type.name }}
          </v-chip>
          <v-chip
            v-if="item.type.name == 'Live'"
            color="red lighten-5"
            label
            small
            text-color="red"
          >
            <v-icon left small>{{ item.type.icon }}</v-icon>
            {{ item.type.name }}
          </v-chip>
          <v-chip
            v-if="item.type.name == 'Exam'"
            color="teal lighten-5"
            label
            small
            text-color="teal"
          >
            <v-icon left small>{{ item.type.icon }}</v-icon>
            {{ item.type.name }}
          </v-chip>
          <v-chip
            v-if="item.type.name == 'General'"
            color="blue-grey lighten-5"
            label
            small
            text-color="blue-grey"
          >
            <v-icon left small>{{ item.type.icon }}</v-icon>
            {{ item.type.name }}
          </v-chip> -->
        </template>

        <template v-slot:item.startTime="{ item }">
          <p class="mb-0">
            {{
              !item.event
                ? '-'
                : item.event.startTime | moment('DD/MM/YYYY HH:mm')
            }}
          </p>
        </template>
        <template v-slot:item.endTime="{ item }">
          <p class="mb-0">
            {{
              !item.event
                ? '-'
                : item.event.endTime | moment('DD/MM/YYYY HH:mm')
            }}
          </p>
        </template>
        <template v-slot:item.alert="{ item }">
          <p v-if="item.timeSend == 0" class="mb-0">
            {{ $vuetify.lang.t('$vuetify.eventManagement.notSend') }}
          </p>
          <p v-if="item.alert == null && item.timeSend != 0" class="mb-0">
            {{ $vuetify.lang.t('$vuetify.eventManagement.time') }}:
            {{ item.timeSend | moment('DD/MM/YYYY HH:mm') }}
          </p>
          <p v-if="item.alert == true" class="mb-0 success--text">
            {{ $vuetify.lang.t('$vuetify.eventManagement.sent') }}:
            {{ item.timeSend | moment('DD/MM/YYYY HH:mm') }}
          </p>
          <p v-if="item.alert == false" class="mb-0 error--text">
            {{ $vuetify.lang.t('$vuetify.eventManagement.sentFail') }}:
            {{ item.timeSend | moment('DD/MM/YYYY HH:mm') }}
          </p>

          <!-- <v-chip
          v-if="item.alert == null"
          class="ma-2"
          color="orange lighten-5"
          label
          text-color="orange"
        >
          <v-icon left> mdi-bell-cancel-outline </v-icon>
          Not Sending
        </v-chip>
        <v-chip
          v-if="item.alert == true"
          class="ma-2"
          color="green lighten-5"
          label
          text-color="green"
        >
          <v-icon left> mdi-bell-check-outline </v-icon>
          Success
        </v-chip>
        <v-chip
          v-if="item.alert == false"
          class="ma-2"
          color="red lighten-5"
          label
          text-color="red"
        >
          <v-icon left> mdi-bell-alert-outline </v-icon>
          Sent failed
        </v-chip> -->
        </template>
        <template v-slot:item.active="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <div class="text-center" v-on="on">
                <v-switch
                  color="rgb(66, 154, 216)"
                  inset
                  v-model="item.active"
                  @click="openModalStatus(item)"
                ></v-switch>
              </div>
            </template>
            <span v-if="item.active">{{
              $vuetify.lang.t('$vuetify.categoryManagement.clickToSuspend')
            }}</span>
            <span v-else>{{
              $vuetify.lang.t('$vuetify.categoryManagement.clickToActivate')
            }}</span>
          </v-tooltip>
        </template>

        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-center">
            <v-btn
              elevation="0"
              class="mb-0 body-2 text-primary text-capitalize"
              color="white"
              @click="editItem(item)"
            >
              <p class="mb-0">
                {{ $vuetify.lang.t('$vuetify.eventManagement.edit') }}
              </p>
            </v-btn>
            <v-divider inset vertical class="mb-2 mx-1"></v-divider>

            <v-btn
              elevation="0"
              class="mb-0 body-2 error--text text-capitalize"
              color="white"
              @click="confirmDelete(item)"
            >
              <p class="mb-0">
                {{ $vuetify.lang.t('$vuetify.eventManagement.delete') }}
              </p>
            </v-btn>
          </div>
        </template>
      </v-data-table>

      <div class="text-center">
        <hr class="hr-top-pagination" />
      </div>
      <div class="pa-0 ma-0">
        <v-pagination
          class="py-5"
          v-model="params.page"
          :length="pageCount"
          @input="changePage"
          :total-visible="10"
        ></v-pagination>
      </div>
    </div>

    <!-- </v-card> -->

    <v-dialog v-model="dialogStatus" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t('$vuetify.eventManagement.confirmSuspend')
        }}</v-card-title>
        <v-card-text>{{
          $vuetify.lang.t('$vuetify.eventManagement.suspendDetail')
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" dark outlined @click="cancelStatus()">{{
            $vuetify.lang.t('$vuetify.eventManagement.cancel')
          }}</v-btn>
          <v-btn
            color="error darken-1"
            dark
            @click="updateActiveNotification()"
            >{{ $vuetify.lang.t('$vuetify.eventManagement.confirm') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogStatusActive" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t('$vuetify.eventManagement.confirmActivate')
        }}</v-card-title>
        <v-card-text>{{
          $vuetify.lang.t('$vuetify.eventManagement.activateDetail')
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            dark
            outlined
            @click="cancelStatusActive()"
            >{{ $vuetify.lang.t('$vuetify.eventManagement.cancel') }}</v-btn
          >
          <v-btn
            color="button-primary"
            dark
            @click="updateActiveNotification()"
            >{{ $vuetify.lang.t('$vuetify.eventManagement.confirm') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSuccess" max-width="500">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t('$vuetify.eventManagement.successfullySave')
        }}</v-card-title>

        <v-card-text>{{
          $vuetify.lang.t('$vuetify.eventManagement.canModifyLater')
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialogSuccess = false">{{
            $vuetify.lang.t('$vuetify.eventManagement.done')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t('$vuetify.eventManagement.msg.msg2')
        }}</v-card-title>
        <v-card-text>
          <p>
            {{ $vuetify.lang.t('$vuetify.eventManagement.msg.msg3') }}
          </p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            elevation="0"
            class="px-7 ma-2 subtitle-2 font-weight-light text-capitalize"
            color="grey darken-1"
            outlined
            :disabled="this.loadingDelete == true"
            @click="dialogDelete = false"
            >{{ $vuetify.lang.t('$vuetify.eventManagement.cancel') }}</v-btn
          >
          <v-btn
            elevation="0"
            class="px-7 ma-2 subtitle-2 font-weight-light text-capitalize"
            color="error darken-1"
            :disabled="this.loadingDelete == true"
            @click="deleteNotification()"
            ><p class="pa-0 ma-0">
              {{ $vuetify.lang.t('$vuetify.eventManagement.confirm') }}
            </p>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row justify="center">
      <v-dialog v-model="alert" persistent max-width="450">
        <v-card>
          <v-card-title class="headline">{{
            $vuetify.lang.t('$vuetify.categoryManagement.sorry')
          }}</v-card-title>
          <v-card-text>
            {{ $vuetify.lang.t('$vuetify.categoryManagement.msg.msg1') }}
            <strong
              >&nbsp;{{
                $vuetify.lang.t('$vuetify.categoryManagement.msg.msg2')
              }}&nbsp;</strong
            >
            {{ $vuetify.lang.t('$vuetify.categoryManagement.msg.msg3') }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click="alert = false">{{
              $vuetify.lang.t('$vuetify.categoryManagement.ok')
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-dialog v-model="dialogRecycleBin" scrollable persistent width="1200px">
      <v-card>
        <v-toolbar flat dark color="rgb(51, 97, 137)">
          <v-toolbar-title>
            <v-icon left>mdi-delete-outline</v-icon
            >{{ $vuetify.lang.t('$vuetify.courseManagement.filterBar.bin') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn icon dark @click="closeDialogRecycleBin" v-on="on">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <span class="subtitle-1">{{
              $vuetify.lang.t('$vuetify.courseManagement.close')
            }}</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :loading="loading"
                :headers="headersBin"
                hide-default-footer
                :items="notiListBin"
                class="pa-mb-5 font-weight-light"
              >
                <template v-slot:item.image="{ item }">
                  <v-img
                    :src="item.image"
                    class="my-2 rounded-card"
                    width="100"
                    aspect-ratio="1.7"
                  >
                    <template v-slot:placeholder>
                      <v-row class="ma-0" align="center" justify="center">
                        <v-icon
                          v-if="!item.image"
                          class="mx-auto"
                          elevation="3"
                          size="50"
                          >mdi-image-outline</v-icon
                        >
                      </v-row>
                    </template>
                  </v-img>
                </template>

                <template v-slot:item.title="{ item }">
                  <p class="mb-0">{{ item.title }}</p>
                </template>

                <template v-slot:item.detail="{ item }">
                  <p class="mb-0">{{ item.detail }}</p>
                </template>

                <template v-slot:item.lectureType="{ item }">
                  <p class="mb-0">
                    {{ item.type.name }}
                  </p>
                </template>

                <template v-slot:item.startTime="{ item }">
                  <p class="mb-0">
                    {{
                      !item.event
                        ? '-'
                        : item.event.startTime | moment('DD/MM/YYYY HH:mm')
                    }}
                  </p>
                </template>
                <template v-slot:item.endTime="{ item }">
                  <p class="mb-0">
                    {{
                      !item.event
                        ? '-'
                        : item.event.endTime | moment('DD/MM/YYYY HH:mm')
                    }}
                  </p>
                </template>
                <template v-slot:item.alert="{ item }">
                  <p v-if="item.timeSend == 0" class="mb-0">ไม่ส่งแจ้งเตือน</p>
                  <p
                    v-if="item.alert == null && item.timeSend != 0"
                    class="mb-0"
                  >
                    {{ $vuetify.lang.t('$vuetify.eventManagement.time') }}:
                    {{ item.timeSend | moment('DD/MM/YYYY HH:mm') }}
                  </p>
                  <p v-if="item.alert == true" class="mb-0 success--text">
                    {{ $vuetify.lang.t('$vuetify.eventManagement.sent') }}:
                    {{ item.timeSend | moment('DD/MM/YYYY HH:mm') }}
                  </p>
                  <p v-if="item.alert == false" class="mb-0 error--text">
                    {{ $vuetify.lang.t('$vuetify.eventManagement.sentFail') }}:
                    {{ item.timeSend | moment('DD/MM/YYYY HH:mm') }}
                  </p>
                </template>

                <template v-slot:item.actions="{ item }">
                  <div class="d-flex justify-center">
                    <v-btn
                      elevation="0"
                      class="mb-0 body-2 text-primary text-capitalize"
                      color="white"
                      @click="confirmRecover(item)"
                    >
                      <p class="mb-0">
                        {{
                          $vuetify.lang.t('$vuetify.eventManagement.recover')
                        }}
                      </p>
                    </v-btn>
                  </div>
                </template>
              </v-data-table>
              <div class="pt-3 pr-3 pb-5 text-center">
                <v-pagination
                  v-model="paramsBin.page"
                  :length="pageCountBin"
                  @input="changePageBin"
                  color="rgb(66, 154, 216)"
                ></v-pagination>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogRecover" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t('$vuetify.eventManagement.msg.msg5')
        }}</v-card-title>
        <v-card-text>
          <p>
            {{ $vuetify.lang.t('$vuetify.eventManagement.msg.msg6') }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            elevation="0"
            class="
              px-9
              ma-2
              subtitle-2
              button-secondary
              font-weight-light
              text-capitalize
            "
            outlined
            :disabled="this.loadingRecover == true"
            @click="dialogRecover = false"
            >{{ $vuetify.lang.t('$vuetify.eventManagement.cancel') }}</v-btn
          >
          <v-btn
            class="
              px-10
              ma-2
              subtitle-2
              text-capitalize
              font-weight-light
              button-primary
            "
            :disabled="this.loadingRecover == true"
            @click="recoverNotification()"
            ><p v-if="loadingRecover == false" class="pa-0 ma-0">
              {{ $vuetify.lang.t('$vuetify.eventManagement.confirm') }}
            </p>
            <p v-if="loadingRecover == true" class="pa-0 ma-0">
              {{ $vuetify.lang.t('$vuetify.eventManagement.moving') }}
            </p></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogMultiRecoverSuccess" max-width="500">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t('$vuetify.eventManagement.msg7')
        }}</v-card-title>

        <v-card-text>{{
          $vuetify.lang.t('$vuetify.eventManagement.msg8')
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="closeDialogRecover">{{
            $vuetify.lang.t('$vuetify.eventManagement.done')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <notification-dialog
      :openDialogPushNotice.sync="isPushNoticeDialogOpen"
      :closePushNoticeDialog.sync="closePushNoticeDialog"
      :typeNotice.sync="typeNotice"
      :noticeId.sync="noticeId"
      :courseId.sync="courseId"
      :subId.sync="subId"
      :titleNotice.sync="titleNotice"
      :messageNotice.sync="messageNotice"
      :urlNotice.sync="url"
      :imageNotice.sync="imageNotice"
      :timeSendNotice.sync="timeSendNotice"
      :targetNotice.sync="targetNotice"
      :platformNotice.sync="platformNotice"
      :event.sync="event"
      :courses.sync="courses"
      :usergroup.sync="usergroup"
      :alertNotice.sync="alertNotice"
      :stausNotice.sync="statusNotification"
    ></notification-dialog>
  </div>
</template>

<script>
import {
  loadListNotification,
  updateActive,
  deleteNotification,
  loadListBinNotification,
} from '@/service/notifications/notification';
import notificationDialog from '@/views/course/dialog/pushNotificationDialog.vue';
export default {
  components: {
    notificationDialog,
  },
  data() {
    return {
      noticeId: '',
      isPushNoticeDialogOpen: false,
      typeNotice: '',
      titleNotice: '',
      messageNotice: '',
      imageNotice: '',
      timeSendNotice: 0,
      platformNotice: '',
      targetNotice: '',
      subId: '',
      courseId: '',
      event: {
        startTime: '',
        endTime: '',
      },
      alertNotice: null,

      indexItem: null,
      status_toggle: 0,
      valid: true,
      alert: false,
      imageFile: null,
      categoryName: '',
      categoryID: '',

      descriptionRules: [
        (v) => !!v || 'Description of the Category is required',
      ],
      description: 'Description of ENGLSIH WITH PETCH Category',

      categoryLogo: 'https://cdn.vuetifyjs.com/images/parallax/material2.jpg',

      imageReady: true,
      imageRules: [
        (v) =>
          !v ||
          v.size < 20000000 ||
          v == '' ||
          'Image size should be less than 20 MB!',
      ],

      filterdialog: false,
      deleteDialog: false,
      loading: true,
      sortType: ['ที่เพิ่มใหม่สุด', 'ที่เพิ่มเก่าสุด'],

      category: [],
      notiList: [],
      searchdata: '',
      sortData: '',
      searchCategory: null,
      pageCount: 1,
      limit: 10,
      imgPreview: '',
      skill: [],
      selectedSkill: [],
      selectedCategory: [],
      active: '',
      params: {},
      deleteItemID: [],
      categoryActive: false,
      actionEdit: '',
      levelSub: '',
      priority: '',
      dialogStatus: false,
      dialogStatusActive: false,
      dialogSuccess: false,

      dialogDelete: false,
      actionDeleteNotification: [],
      loadingDelete: false,
      dialogRecycleBin: false,
      notiListBin: [],
      loadingBin: false,
      actionNotificationBin: [],
      dialogRecover: false,
      dialogMultiRecoverSuccess: false,
      loadingRecover: false,

      preparePreview: '',
    };
  },
  async mounted() {
    await this.initialize();
    // console.log("window.screen.width:",window.screen.width/3)
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    fileRules() {
      const rules = [];

      // insert
      if (this.categoryID === '') {
        const rule = (v) =>
          !!v || this.$vuetify.lang.t('$vuetify.categoryManagement.fileRules');
        rules.push(rule);
      }
      if (this.categoryID === '') {
        const rule = (v) =>
          (v && v.size < 20000000) ||
          this.$vuetify.lang.t('$vuetify.categoryManagement.fileRulesSize');
        rules.push(rule);
      }

      // update
      // if (this.categoryID !== "" && this.imageFile == "") {
      //   const rule = v => ( v && v.size < 5000000)  || "Image size should be less than 5 MB!";
      //   rules.push(rule);
      // }
      if (this.categoryID !== '') {
        const rule = (v) =>
          (v ? (v.size < 20000000 ? true : false) : true) ||
          this.$vuetify.lang.t('$vuetify.categoryManagement.fileRulesSize');
        rules.push(rule);
      }
      return rules;
    },
    categoryNameRules() {
      return [
        (v) =>
          !!v ||
          this.$vuetify.lang.t('$vuetify.categoryManagement.categoryNameRules'),
        (v) =>
          (v && v.length <= 50) ||
          this.$vuetify.lang.t(
            '$vuetify.categoryManagement.categoryNameRulesLimit'
          ),
      ];
    },
    headers() {
      return [
        {
          text: this.$vuetify.lang.t('$vuetify.eventManagement.header.photo'),
          align: 'center',
          sortable: false,
          value: 'image',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.eventManagement.header.eventName'
          ),
          value: 'title',
          sortable: false,
          width: '200',
        },
        {
          text: this.$vuetify.lang.t('$vuetify.eventManagement.header.detail'),
          value: 'detail',
          sortable: false,
          width: '200',
        },
        {
          text: this.$vuetify.lang.t('$vuetify.eventManagement.header.type'),
          value: 'lectureType',
          align: 'center',
          sortable: false,
          width: '150',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.eventManagement.header.startTime'
          ),
          value: 'startTime',
          align: 'center',
          sortable: false,
          width: '200',
        },
        {
          text: this.$vuetify.lang.t('$vuetify.eventManagement.header.endTime'),
          value: 'endTime',
          align: 'center',
          sortable: false,
          width: '200',
        },
        {
          text: this.$vuetify.lang.t('$vuetify.eventManagement.header.alert'),
          align: 'center',
          value: 'alert',
          sortable: false,
          width: '230',
        },
        {
          text: this.$vuetify.lang.t('$vuetify.eventManagement.header.status'),

          value: 'active',
          sortable: false,
        },
        {
          text: '',
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ];
    },
    headersBin() {
      return [
        {
          text: this.$vuetify.lang.t('$vuetify.eventManagement.header.photo'),
          align: 'center',
          sortable: false,
          value: 'image',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.eventManagement.header.eventName'
          ),
          value: 'title',
          sortable: false,
          width: '200',
        },
        {
          text: this.$vuetify.lang.t('$vuetify.eventManagement.header.detail'),
          value: 'detail',
          sortable: false,
          width: '200',
        },
        {
          text: this.$vuetify.lang.t('$vuetify.eventManagement.header.type'),
          value: 'lectureType',
          sortable: false,
          align: 'center',
          width: '150',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.eventManagement.header.startTime'
          ),
          value: 'startTime',
          align: 'center',
          sortable: false,
          width: '200',
        },
        {
          text: this.$vuetify.lang.t('$vuetify.eventManagement.header.endTime'),
          value: 'endTime',
          align: 'center',
          sortable: false,
          width: '200',
        },
        {
          text: this.$vuetify.lang.t('$vuetify.eventManagement.header.alert'),
          align: 'center',
          value: 'alert',
          sortable: false,
          width: '230',
        },
        {
          text: '',
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ];
    },
  },
  watch: {
    searchdata(keyword) {
      this.searchInfo(keyword);
    },
  },
  methods: {
    async initialize() {
      this.params = {
        // search: this.searchCategory,
        sort: 'created_at',
        sortby: -1,
        page: 1,
        limit: 10,
        // active: "null",
        company: this.$store.state.company._id,
      };
      this.paramsBin = {
        // search: null,
        sort: 'created_at',
        sortby: -1,
        page: 1,
        limit: 10,
        // active: "null",
        company: this.$store.state.company._id,
      };
      this.searchdata = '';
      this.status_toggle = 0;

      if (!this.$store.state.permission.viewCategory) {
        this.noPermission();
      } else {
        // await this.getCategoryList();
        this.getNotificationList();
      }
    },
    searchInfo(keyword) {
      this.params.search = keyword;
      this.params.page = 1;
      this.getNotificationList();
    },
    onSort() {
      if (this.status_toggle == 1) {
        this.params.active = true;
        this.getNotificationList();
      } else if (this.status_toggle == 2) {
        this.params.active = false;
        this.getNotificationList();
      } else {
        this.params.active = 'null';
        this.getNotificationList();
      }
    },

    refreshFilter() {
      this.initialize();
    },

    async getNotificationList() {
      this.loading = true;
      let result = await loadListNotification(this.params);
      this.notiList = [];
      this.pageCount = result.maxPage;
      result.data.forEach((noti) => {
        let lectureType = {};
        switch (noti.type) {
          case 'COURSE':
            lectureType = {
              title: noti.course.title,
              courseId: noti.course._id,
              icon: 'mdi-youtube-tv',
              name: 'Course',
              iconClass: 'grey lighten-1 black--text',
            };
            break;

          case 'LIVE':
            lectureType = {
              // title: noti.livestream.title,
              courseId: noti.course._id,
              liveId: noti.livestreamv2,
              // icon: "mdi-video-wireless-outline",
              icon: 'mdi-access-point',
              name: 'Live',
              iconClass: 'grey lighten-1 black--text',
            };
            break;

          case 'EXAM':
            lectureType = {
              title: noti.exam.title,
              courseId: noti.course._id,
              examId: noti.exam._id,
              icon: 'mdi-format-annotation-plus',
              name: 'Exam',
              iconClass: 'grey lighten-1 black--text',
            };
            break;

          case 'GENERAL':
            lectureType = {
              title: 'Event',
              icon: 'mdi-bell-ring',
              name: 'General',
              iconClass: 'grey lighten-1 black--text',
            };
            break;

          case 'URL':
            lectureType = {
              title: 'Event',
              icon: 'mdi-link-variant',
              name: 'URL',
              iconClass: 'grey lighten-1 black--text',
            };
            break;

          default:
            lectureType = {
              icon: 'mdi-bell',
              iconClass: 'grey lighten-1 black--text',
            };
            break;
        }
        this.notiList.push({
          id: noti._id,
          title: noti.title,
          detail: noti.body,
          url: noti.url,
          timeSend: noti.timesend,
          alert: noti.sendSuccess,
          image: noti.image,
          create: noti.created_at,
          active: noti.active,
          type: lectureType,
          platform: noti.platform,
          target: noti.target,
          event: noti.event,
          courses: noti.courses,
          usergroup: noti.user_groups,
          statusNotification: noti.statusNotification,
        });
      });
      console.log(this.notiList);
      this.loading = false;
    },

    noPermission() {
      this.alert = true;
    },
    async changePage(page) {
      this.params.page = page;
      await this.getNotificationList();
    },
    editItem(item) {
      console.log('editItem -> item', item);
      this.noticeId = item.id;

      if (item.type.name.toUpperCase() === 'GENERAL') {
        this.typeNotice = 'GENERAL';
      } else {
        this.typeNotice = item.type.name.toUpperCase();
      }

      if (this.typeNotice === 'COURSE') {
        this.courseId = item.type.courseId;
      } else if (this.typeNotice === 'LIVE') {
        this.courseId = item.type.courseId;
        this.subId = item.type.liveId;
      } else if (this.typeNotice === 'EXAM') {
        this.courseId = item.type.courseId;
        this.subId = item.type.examId;
      } else if (this.typeNotice === 'URL') {
        this.courseId = item.type.courseId;
        this.subId = item.type.examId;
      }

      this.imageNotice = item.image;
      this.messageNotice = item.detail;
      this.url = item.url;
      this.titleNotice = item.title;
      this.platformNotice = item.platform;
      this.targetNotice = item.target;
      this.timeSendNotice = item.timeSend;
      this.event.startTime = item.event ? item.event.startTime : '';
      this.event.endTime = item.event ? item.event.endTime : '';
      this.courses = item.courses;
      this.usergroup = item.usergroup;
      this.alertNotice = item.alert;
      this.statusNotification = item.statusNotification;

      this.isPushNoticeDialogOpen = true;
    },
    confirmDelete(item) {
      this.actionDeleteNotification = item;

      this.dialogDelete = true;
    },
    async deleteNotification() {
      // let arrayid = [];
      this.loadingDelete = true;
      if (
        this.actionDeleteNotification.active == true &&
        this.actionDeleteNotification.alert == false
      ) {
        this.updateActiveId = this.actionDeleteNotification.id;
        await updateActive({
          idschedule: this.updateActiveId,
          active: false,
        });
      }
      // arrayid.push({ id: this.actionDeleteNotification.id });
      // console.log(arrayid);
      let result = await deleteNotification({
        idschedule: this.actionDeleteNotification.id,
        istrash: true,
      });
      console.log(result);

      this.loadingDelete = false;
      this.dialogDelete = false;
      this.dialogMultiDeleteSuccess = true;

      this.actionDeleteNotification = [];
      this.page = 1;
      this.pageCount - 1;
      await this.initialize();
    },
    async openRecycleBin() {
      this.dialogRecycleBin = true;
      await this.getNotificationListBin();
    },

    confirmRecover(item) {
      this.actionNotificationBin = item;

      console.log(this.actionNotificationBin);
      this.dialogRecover = true;
    },
    async recoverNotification() {
      // let arrayid = [];
      this.loadingRecover = true;
      // arrayid.push({ id: this.actionNotificationBin.id });
      // console.log(arrayid);
      let result = await deleteNotification({
        idschedule: this.actionNotificationBin.id,
        istrash: false,
      });
      console.log(result);

      this.loadingRecover = false;
      this.dialogRecover = false;
      this.dialogMultiRecoverSuccess = true;

      this.actionNotificationBin = [];
      this.page = 1;
      this.pageCount - 1;
      await this.initialize();
    },
    async closeDialogRecycleBin() {
      this.dialogRecycleBin = false;
      await this.getNotificationList();
    },
    closeDialogRecover() {
      this.dialogMultiRecoverSuccess = false;
      this.dialogRecycleBin = false;
    },
    closeDialog() {
      this.categoryID = '';

      this.categoryName = '';
      this.imageFile = null;
      this.imgPreview = '';
      this.preparePreview = ''; //valid image

      this.$refs.form.resetValidation();
      this.imageReady = true;
    },
    openModalStatus(item) {
      let index = this.notiList.indexOf(item);
      this.indexItem = index;
      if (this.notiList[index].active == true) {
        this.dialogStatus = true;
        this.updateActiveId = this.notiList[index].id;
        this.updateActive = this.notiList[index].active;
      } else {
        this.dialogStatusActive = true;
        this.updateActiveId = this.notiList[index].id;
        this.updateActive = this.notiList[index].active;
      }
    },
    async updateActiveNotification() {
      if (this.updateActive == true) {
        let status = await updateActive({
          idschedule: this.updateActiveId,
          active: false,
        });
        this.dialogStatus = false;
        this.dialogSuccess = true;
        this.getNotificationList();
        return status;
      } else {
        let status = await updateActive({
          idschedule: this.updateActiveId,
          active: true,
        });
        this.dialogStatusActive = false;
        this.dialogSuccess = true;
        this.getNotificationList();
        return status;
      }
    },
    cancelStatus() {
      this.dialogStatus = false;
      this.notiList[this.indexItem].active = this.updateActive;
    },
    cancelStatusActive() {
      this.dialogStatusActive = false;
      this.notiList[this.indexItem].active = this.updateActive;
    },
    openPushNoticeDialog(type) {
      this.typeNotice = type;
      this.isPushNoticeDialogOpen = true;
    },
    closePushNoticeDialog() {
      this.typeNotice = '';
      this.noticeId = '';
      this.isPushNoticeDialogOpen = false;
      this.initialize();
    },
  },
};
</script>
<style scoped>
.btn-reload {
  background: #ffffff !important;
  border: 1px solid #d9d9d9;
  color: rgb(77, 77, 77);
  box-shadow: none !important;
}
.text-primary {
  color: rgb(66, 154, 216) !important;
}
.hr-top-pagination {
  border-top: 1px solid #d1d1d1;
}
.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
.title-text {
  color: rgb(140, 140, 140);
}
.btnMargin {
  margin-bottom: 10px;
}
.mainRowActionBtn {
  justify-content: flex-end;
}
.subRowActionBtn {
  justify-content: flex-end;
}
.sizeImg {
  /* z-index: -1; */
  position: absolute;
  top: 9px;
  left: 10px;
  width: 60%;
  height: 60%;
}
.sizeImgDialogAdd {
  /* z-index: -1; */
  position: absolute;
  top: 40px;
  left: 40px;
  width: 60%;
  height: 60%;
}
.v-image {
  border-radius: unset;
  display: inline-flex;
}
.v-label.theme--light {
  left: 0px;
  right: auto;
  top: auto;
  position: absolute;
}
.v-icon.notranslate.v-icon--link.mdi.mdi-camera.theme--light {
  bottom: 10px;
}
.text-field-border {
  border: 1px solid;
  border-radius: 4px;
  border-color: rgba(65, 65, 65, 0.3);
  height: 40px;
}
</style>
<style>
/* .labelField > .v-label.theme--light {
  left: 0px;
  right: auto;
  top: auto;
  position: absolute;
} */
.v-icon.notranslate.v-icon--link.mdi.mdi-camera.theme--light {
  bottom: 10px;
}
.v-icon.notranslate.v-icon--link.mdi.mdi-close.theme--light {
  top: auto;
}

.v-label.theme--light {
  left: 0px;
  right: auto;
  top: auto;
  position: absolute;
}
.btnMargin {
  margin-bottom: 10px;
}
.mainRowActionBtn {
  justify-content: flex-end;
}
.subRowActionBtn {
  justify-content: flex-end;
}
.sizeImg {
  /* z-index: -1; */
  position: absolute;
  top: 14px;
  left: 14px;
  width: 60%;
  height: 60%;
}
.rounded-card {
  border-radius: 8px;
}
.v-text-field--filled > .v-input__control > .v-input__slot,
.v-text-field--full-width > .v-input__control > .v-input__slot,
.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 40px;
}
.md-fixed-max-width {
  max-width: 250px;
}
.max-width {
  width: 100%;
}
.img-md {
  width: 80px;
}

@media only screen and (max-width: 1440px) {
  .md-fixed-width {
    width: 150px;
  }
  .xs-fixed-width {
    width: 100px;
  }
}
@media only screen and (max-width: 768px) {
  .img-md {
    width: 60px;
    height: 60px;
  }
  .md-fixed-width {
    width: 150px;
  }
  .xs-fixed-width {
    width: 100px;
  }
  .xs-m {
    margin-top: 28px !important;
  }
  .xs-full-max-width {
    max-width: 100%;
  }
  .table-header {
    height: auto !important;
  }
  .table-header .v-toolbar__content {
    height: auto !important;
    flex-flow: column;
    padding: 0 !important;
  }
  .xs-full-width {
    width: 50%;
  }
}

.custom-toolbar {
  background: #f2f3f5 !important;
}
.rounded-card {
  border-radius: 8px;
}
</style>
